import styled from 'styled-components';

export const StyledNoResultsEmpty = styled.div`
  flex: 1;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(props): string => props.theme.kcc.spacing.SM};

  .no-results-empty__icon {
    width: 64px;
    height: 64px;
    flex-shrink: 0;

    svg {
      width: 64px;
      height: 64px;

      path {
        fill: ${(props): string => props.theme.kcc.colors.GRAY_400};
      }
    }
  }

  .no-results-empty__title {
    font-size: ${(props): string => `${props.theme.kcc.typography.FONT_SIZE.BASE}px`};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    text-align: center;
    display: block;
  }

  .no-results-empty__description {
    font-size: ${(props): string => `${props.theme.kcc.typography.FONT_SIZE.BASE}px`};
    color: ${(props): string => props.theme.kcc.colors.TEXT_SECONDARY};
    text-align: center;
    display: block;
  }
`;
